<quill-editor [(ngModel)]="value" [readOnly]="quillOptions.readOnly" [style]="quillOptions.style" [placeholder]="quillOptions.placeholder"
 [required]="quillOptions.required" [modules]="quillOptions.modules"></quill-editor>
